export const MENU_BAR_HEADER_HEIGHT = 64;
export const MENU_BAR_HEADER_HEIGHT_PX = '64px';
